export default "__VITE_ASSET__Cuyl41qU__"